<div class="password-box">
    <input ngDefaultControl [(ngModel)]="password" (ngModelChange)="valueChanged($event)"
        [attr.type]="showPassword ? 'text' : 'password'" type="password" autocomplete="password"
        placeholder="{{'placeholders.password' | translate}}"
        class="form-control form-control-lg shadow text-givt-purple" />
    <span (click)="showPassword = !showPassword" class="pass-eye" id="pass-eye">
        <svg xmlns:xlink="http://www.w3.org/1999/xlink" height="14px" version="1.1" viewBox="273 182 16 14" width="16px"
            xmlns="http://www.w3.org/2000/svg">
            <defs></defs>
            <path
                d="M288.945312,187.8125 L288.90625,187.757812 C288.90625,187.757812 285.5,182.664062 281,182.664062 C276.5,182.664062 273.054688,187.8125 273.054688,187.8125 C272.984375,187.929688 272.984375,188.070312 273.054688,188.1875 C273.054688,188.1875 276.5,193.335938 281,193.335938 C285.5,193.335938 288.945312,188.1875 288.945312,188.1875 C289.015625,188.070312 289.015625,187.929688 288.945312,187.8125 L288.945312,187.8125 Z M281,191 C279.335938,191 278,189.664062 278,188 C278,186.351562 279.335938,185 281,185 C282.648438,185 284,186.351562 284,188 C284,189.664062 282.648438,191 281,191 L281,191 Z"
                fill-rule="evenodd" id="eye" stroke="none" fill="#000"></path>
        </svg>
    </span>
</div>
<small class="form-text text-right text-givt-purple text-light-font" *ngIf='showPasswordHint'>
    <div dir="rtl">
        <li> {{'passwordInputComponent.help-text1' | translate}}</li>
        <li> {{'passwordInputComponent.help-text2' | translate}}</li>
        <li> {{'passwordInputComponent.help-text3' | translate}}</li>
    </div>
</small>

